import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import styled, { css } from 'styled-components';
import { StyledButton } from '../Button/style.js';

var PrimaryButtonStyles = function PrimaryButtonStyles(props) {
  var styles = props.children.map(function (child) {
    if (child.props.primary) {
      return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        &:not(:last-child) {\n          margin-right: 1px;\n        }\n      "], ["\n        &:not(:last-child) {\n          margin-right: 1px;\n        }\n      "])));
    }

    return true;
  });
  return styles;
};

var ButtonGroupStyled = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", " {\n    margin: 0;\n    border-radius: 0;\n\n    &:first-child {\n      border-radius: 5px 0 0 5px;\n      border-right: 0px;\n    }\n\n    &:last-child {\n      border-radius: 0 5px 5px 0;\n    }\n    ", "\n    &:active {\n      transform: scale(1) !important;\n    }\n    ", "\n  }\n"], ["\n  ", " {\n    margin: 0;\n    border-radius: 0;\n\n    &:first-child {\n      border-radius: 5px 0 0 5px;\n      border-right: 0px;\n    }\n\n    &:last-child {\n      border-radius: 0 5px 5px 0;\n    }\n    ", "\n    &:active {\n      transform: scale(1) !important;\n    }\n    ", "\n  }\n"])), StyledButton, function (props) {
  return props.children && props.children.length > 2 && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        &:last-child {\n          border-left: 0px;\n        }\n      "], ["\n        &:last-child {\n          border-left: 0px;\n        }\n      "])));
}, function (props) {
  return PrimaryButtonStyles(props);
});
var templateObject_1, templateObject_2, templateObject_3;
export { ButtonGroupStyled };